export interface IHeaderState {
    searchShow: boolean
    showLanguages: boolean    
}

export interface IHeaderStoreAction {
	type: EHeaderStateActionTypes
	[key: string]: any 
}

export type HeaderDispatchAction = (action: IHeaderStoreAction) => void

export enum EHeaderStateActionTypes {
    UpdateSearchShow,
    UpdateShowLanguages
}